import lazySizes from 'lazysizes';

lazySizes.cfg.loadMode = 2;
lazySizes.cfg.preloadAfterLoad = true;

document.addEventListener('lazybeforeunveil', function(e) {
  var bg = e.target.getAttribute('data-bg');
  if (bg) {
    e.target.style.backgroundImage = 'url(' + bg + ')';
  }
});

if ('objectFit' in document.documentElement.style === false) {
  window.addEventListener('load', () => {
    Array.prototype.forEach.call(document.querySelectorAll('img[data-object-fit]'), image => {
      (image.runtimeStyle || image.style).background = `url("${image.src}") no-repeat 50%/${
        image.currentStyle ? image.currentStyle['object-fit'] : image.getAttribute('data-object-fit')
      }`;
      image.src = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${image.width}' height='${image.height}'%3E%3C/svg%3E`;
    });
  });
}
